import templateCollection from "@/vuex/modules/template-collection.module"
import scimApiKey from "@/vuex/modules/scim-api-key.module"
import presentations from "@/vuex/modules/presentations.module"

export default {
  templateCollection,
  scimApiKey,
  presentations,
}